import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { OcppLogMessageFormatted } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import { isOcppLogCallResultMessageRemoteStartTransaction } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.utils';
import { useTranslation } from 'react-i18next';

import { Logger } from '@app/core/logger/logger';
import { DefaultLogComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/default-log.component';
import { LogItemWrapper } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/log-item-wrapper.component';

export const RemoteStartTransactionComponent = ({
  log,
}: {
  log: OcppLogMessageFormatted;
}): React.JSX.Element => {
  const { t } = useTranslation();

  if (!isOcppLogCallResultMessageRemoteStartTransaction(log.message)) {
    Logger.error(
      'Message is not of type OcppLogCallResultMessageRemoteStartTransaction',
      { log },
    );
    return <DefaultLogComponent log={log} />;
  }

  return (
    <LogItemWrapper call={log.message}>
      <Stack direction="column" gap={GapEnum.S}>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-remote-start-transaction-message-request.id-tag',
            )}
          </Text>{' '}
          {log.message.parameters.idTag ?? '-'}
        </Stack>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-remote-start-transaction-message-request.connector-id',
            )}
          </Text>{' '}
          {log.message.parameters.connectorId ?? '-'}
        </Stack>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-remote-start-transaction-message-request.status',
            )}
          </Text>{' '}
          {log.message.result.status ?? '-'}
        </Stack>
      </Stack>
    </LogItemWrapper>
  );
};
